import { Backdrop, Button, CircularProgress } from "@mui/material";

export const Overlay = ({ isVisible, onProcessAbort }: { isVisible: boolean; onProcessAbort?: any }) => (
  <Backdrop open={isVisible} sx={{ zIndex: 2000, color: "#fff" }}>
    <CircularProgress color="inherit" />
    {onProcessAbort ? (
      <Button
        variant="contained"
        color="error"
        onClick={onProcessAbort}
        sx={{ position: "fixed", top: 100, right: 100 }}
      >
        Cancel
      </Button>
    ) : null}
  </Backdrop>
);
